import { useLayoutEffect, useState } from 'react'

export const NOW_REFRESH_MS = 10000

const useNow = (enabled: boolean): number => {
  const [now, setNow] = useState(() => Date.now())

  useLayoutEffect(() => {
    if (!enabled) return undefined

    const refresh = () => setNow(Date.now())
    const refreshWhenVisible = () => {
      if (document.visibilityState === 'visible') refresh()
    }

    refresh()
    const interval = setInterval(refresh, NOW_REFRESH_MS)
    document.addEventListener('visibilitychange', refreshWhenVisible)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', refreshWhenVisible)
    }
  }, [enabled])

  return now
}

export default useNow
